// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"231":"8a568e5c","672":"8a568e5c"}[chunkId] + ".chunk.css";
};